module.exports = __webpack_public_path__ + "img/Work_6.c0f5a076.webp";